import { render, staticRenderFns } from "./FranchiseSalesOrders.vue?vue&type=template&id=276a1d6a&"
import script from "./FranchiseSalesOrders.vue?vue&type=script&lang=js&"
export * from "./FranchiseSalesOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports